import { ExamEventActivityLogList } from '@exam-center/exam-event-activity-log-list';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { PaperSection, Flex, Box } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function ActivityLogPage() {
  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.AUDIT_LOG.VIEW]}>
      <Box sx={{ p: (theme) => theme.spacing(6), flex: 1 }}>
        <PaperSection title='Activity Log'>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              p: theme.spacing(6),
              gap: theme.spacing(6),
              height: '100%',
            })}
          >
            <ExamEventActivityLogList />
          </Flex>
        </PaperSection>
      </Box>
    </PermissionGuard>
  );
}
